import * as React from 'react';
import { LoadingSpinner } from '../../../components/LoadingContainer';
import { paths } from '../../../paths';
import { useMatchStats } from '../Stats/useMatchStats';
import { isNil } from '../../../utils/isNil';
import { AssistCard } from './AssistCard';
import { CardsCard } from './CardsCard';
import { ScorerCard } from './ScorerCard';

interface Props {
  matchId: string;
  isOwner: boolean;
  isSignedIn: boolean;
}

export const MatchStatsCards: React.FC<Props> = ({
  matchId,
  isOwner,
  isSignedIn,
}) => {
  const { fetching: statsLoading, stats } = useMatchStats(matchId);
  const showHeading = !isNil(stats.scorers || stats.assists || stats.cards);
  return (
    <>
      {showHeading ? <h2 className="font-semibold">Match Stats</h2> : null}
      {statsLoading ? (
        <div>
          <LoadingSpinner className="border-primary mx-auto" />
        </div>
      ) : null}
      {stats.scorers ? (
        <ScorerCard
          scorers={stats.scorers}
          editLink={isOwner ? paths.match.settings.scorers(matchId) : undefined}
          isSignedIn={isSignedIn}
        />
      ) : null}
      {stats.assists ? (
        <AssistCard
          assists={stats.assists}
          editLink={isOwner ? paths.match.settings.assists(matchId) : undefined}
          isSignedIn={isSignedIn}
        />
      ) : null}
      {stats.cards ? (
        <CardsCard
          cards={stats.cards}
          editLink={isOwner ? paths.match.settings.cards(matchId) : undefined}
          isSignedIn={isSignedIn}
        />
      ) : null}
    </>
  );
};
